import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
  ColorSelect,
  FormatInput,
  GradeSelect,
  SubjectSelect,
} from 'src/components/common'
import InputField from 'src/components/formik/input-field'
import { Select } from 'src/components/select'
import { PAGE_LAYOUTS } from 'src/tools'
import { getTopicsRequest } from 'src/services/api.service'
import { FormItem } from './form/item'

const defaultValues = {
  title: '',
  color: '1',
  subject_id: null,
  grade_id: null,
  topic_id: null,
  level_ids: [],
  total: 5,
  time: 0,
  page_layout: 'one_per_page',
  show_in_marketplace: false,
  price: 0,
  status: 'draft',
}

const PracticeFormAuto = ({
  auto = false,
  onSubmit,
  initialValues = null,
  error,
}) => {
  const [topics, setTopics] = useState([])
  const [levels, setLevels] = useState([])
  const [items, setItems] = useState([{ levelId: null, count: 0 }])

  const PracticeSchema = Yup.object().shape({
    title: Yup.string().required('Required'),
    color: Yup.string().required('Required'),
    subject_id: Yup.string().nullable().required('Required'),
    grade_id: Yup.string().nullable().required('Required'),
    page_layout: Yup.string().required('Required'),
    // topic_id: Yup.string().nullable().required('Required'),
    // total: Yup.number().required('Required').min(1).max(100),
    // time: Yup.number().required('Required').min(0).max(120),
    // level_ids: Yup.array(Yup.string()),
  })

  // console.log('initialValues', initialValues);

  const formik = useFormik({
    initialValues: { ...defaultValues, ...initialValues },
    validationSchema: PracticeSchema,
    onSubmit: (values) => {
      console.log(values)
      onSubmit({
        // grade_id: values.grade_id,
        // subject_id: values.subject_id,
        // color: values.color,
        ...values,
        tasks: Object.values(levels),
      })
    },
  })

  const { grade_id, subject_id, topic_id } = formik.values

  useEffect(() => {
    if (!grade_id || !subject_id) return

    fetchTopics(subject_id, grade_id)
  }, [grade_id, subject_id])

  const fetchTopics = async (subject_id, grade_id) => {
    const result = await getTopicsRequest({
      subject_id,
      grade_id,
      perPage: 1000,
    })
    setTopics(result.data.items || [])
  }

  const handleSubjectChange = (item) => {
    formik.setFieldValue('subject_id', item?.value)
    formik.setFieldValue('topic_id', null)
  }

  const handleGradeChange = (item) => {
    formik.setFieldValue('grade_id', item?.value)
    formik.setFieldValue('topic_id', null)
  }

  // const handleTopicChange = (item) => {
  //   formik.setFieldValue('topic_id', item?.value);
  // }

  const handleAddItem = (e) => {
    e.preventDefault()

    setItems([...items, { levelId: null, count: 0 }])
  }

  const handleDeleteItem = (idx) => () => {
    const filtered = items.filter((x, i) => i !== idx)
    setItems(filtered)
  }

  const onLevelChange = (key) => (value) => {
    console.log('onLevelChange', key, value)
    setLevels({
      ...levels,
      [key]: value,
    })

    console.log(levels)
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-12 col-md-6">
          <InputField formik={formik} name="title">
            <label>Practice name</label>
            <input
              value={formik.values.title}
              onChange={formik.handleChange}
              type="text"
              className="form-control cabinet__input"
              name="title"
              placeholder="Name"
            />
          </InputField>
        </div>
        <div className="col-12 col-md-6">
          <InputField formik={formik} name="color">
            <label>Select color</label>
            <ColorSelect
              value={formik.values.color}
              onChange={(val) => {
                formik.setFieldValue('color', val)
              }}
            />
          </InputField>
        </div>
      </div>

      <div className="row">
        <div className="col-6 col-md-3 col-lg-2">
          <InputField formik={formik} name="subject_id">
            <label>Subject</label>
            <SubjectSelect
              value={formik.values.subject_id}
              onChange={handleSubjectChange}
            />
          </InputField>
        </div>
        <div className="col-6 col-md-3 col-lg-2">
          <InputField formik={formik} name="grade_id">
            <label>Grade</label>
            <GradeSelect
              value={formik.values.grade_id}
              onChange={handleGradeChange}
            />
          </InputField>
        </div>
        <div className="col-12 col-md-4 col-lg-4">
          <InputField formik={formik} name="page_layout">
            <label>Page layout</label>
            <Select
              placeholder="Select"
              value={formik.values.page_layout}
              onChange={(item) => {
                formik.setFieldValue('page_layout', item.value)
              }}
              options={PAGE_LAYOUTS.map((item) => ({
                value: item.value,
                label: item.title,
              }))}
            />
          </InputField>
        </div>
        <div className="col-12 col-md-2 col-lg-2">
          <InputField formik={formik} name="time">
            <label>Time</label>
            <FormatInput
              type="number"
              name="time"
              onChange={formik.handleChange}
              value={formik.values.time}
              className="round_input"
              min={0}
              max={120}
            />
          </InputField>
        </div>
      </div>

      <div>
        {items.map((x, i) => (
          <FormItem
            key={i}
            index={i}
            onDelete={handleDeleteItem(i)}
            topics={topics}
            onChange={onLevelChange(i)}
          />
        ))}
      </div>

      <div className="row">
        <div className="col-12 pb-30">
          <a className="link" href="#" onClick={handleAddItem}>
            + Add Topic
          </a>
        </div>
      </div>

      {error && <div className="summary-error">{error}</div>}

      <div className="row">
        <div className="col-12">
          <button className="primary-btn">Save</button>
        </div>
      </div>
    </form>
  )
}

export default PracticeFormAuto
